import React from 'react';
import SimpleSlider from '../components/SimpleSlider/SimpleSlider';

class HomePage extends React.Component{
    
    componentDidMount() {
        document.title = 'Startup Learning';
    }

    render(){
        return(
                <div>
                    <SimpleSlider />
                    <div className='hero'>
                        <h1 className='title'>Connections to community based learning opportunities, internships and learning adventures</h1>
                    </div>
                </div>
        )
    }
}

export default HomePage;